/**
 * Human label for a task's archive reason, shown in the Archived list:
 *  - manual    → a deliberate per-task archive
 *  - reconcile → auto-archived by sync because it left ClickUp's complete set
 *  - cutoff (and any legacy null) → swept by the go-live cutoff tool
 */
export function archiveReasonLabel(reason: string | null): string {
  switch (reason) {
    case "manual":
      return "Archived";
    case "reconcile":
      return "No longer complete";
    default:
      return "Swept by cutoff";
  }
}
